<template>

    <router-link :to="{ name: 'billing' }" class="meter">
        <div class="meter-header">
            <span>Usage</span>
            <span>{{ perc | numeral('0.[0]%') }}</span>
        </div>
        <div class="meter-body">
            <div class="bar">
                <div class="progress" :class="color" :style="{ width: `${perc * 100}%` }"></div>
            </div>
        </div>
    </router-link>

</template>

<style scoped lang="scss">

    .meter {
        display: block;
        padding: 0 15px;
        text-decoration: none;
        width: 100%;
        &:hover .meter-header {
            opacity: 1;
        }
        .meter-header {
            @include font-medium(11px);
            align-items: center;
            color: #fff;
            display: flex;
            justify-content: space-between;
            opacity: 0.8;
            transition: opacity .3s;
        }
        .meter-body {
            padding: 5px 0;
            .bar {
                background: rgba(255,255,255,0.2);
                border-radius: 2px;
                height: 4px;
                overflow: hidden;
                position: relative;
                width: 100%;
            }
            .progress {
                background: $color-success;
                border-radius: 2px;
                height: 4px;
                left: 0;
                min-width: 4px;
                position: absolute;
                top: 0;
                transition: width .3s;
                width: 50%;
                &.progress-danger {
                    background: $color-danger;
                }
                &.progress-warning {
                    background: $color-warning;
                }
                &.progress-success {
                    background: $color-success;
                }
            }
        }
    }

</style>

<script>

export default {

    computed: {

        company() {
            return this.$store.getters.company;
        },

        count() {
            return this.$store.getters.company.customers_count;
        },

        limit() {
            return this.$store.getters.company.customers_limit;
        },

        perc() {
            if (this.count > this.limit) return 1;
            return this.count / this.limit;
        },

        color() {
            if (this.perc >= 0.7) return 'progress-danger';
            if (this.perc >= 0.5) return 'progress-warning';
            return 'progress-success';
        },

    },

}

</script>